export default __webpack_public_path__ + "static/hurricane3-0e415a459a202cdaeeb50a6dbd31d0c9.png";